import React, {
  FunctionComponent,
  PropsWithChildren,
  useEffect,
  useMemo
} from 'react';
import { NotificationManagerContext } from '../../context/NotificationManagerContext';
import { prepareProps } from '../../utils/propUtils';
import { NotificationManager } from '../classes/NotificationManager/NotificationManager';

export type NotificationManagerProviderProps = PropsWithChildren<
  Record<never, never>
>;

export const NotificationManagerProvider: FunctionComponent<NotificationManagerProviderProps> =
  React.memo((props) => {
    const { children } = prepareProps({ props });

    const notificationManagerContextValue = useMemo(
      () => ({
        notificationManager: new NotificationManager()
      }),
      []
    );

    useEffect(() => {
      return () => {
        notificationManagerContextValue.notificationManager.destroy();
      };
    }, [notificationManagerContextValue]);

    return (
      <NotificationManagerContext.Provider
        value={notificationManagerContextValue}
      >
        {children}
      </NotificationManagerContext.Provider>
    );
  });
